// components/Breadcrumbs.js
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, Breadcrumbs as MUIBreadcrumbs } from "@mui/material";
import React, { useContext } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import CustomTypography from "../../globalStyles/fonts";
import { getObjectByPath } from "../../utils/getObjectByPath";
import { isMobile } from "../../globalStyles/mobile";
import HomeIcon from "../../globalStyles/icons/home-icon";
import { useTheme } from "@mui/styles";
import { useDarkMode } from "../context/darkModeContext";

const Breadcrumbs = () => {
  const theme = useTheme();
  const { colors } = useDarkMode();
  const defaultColor = "#D13438";
  const primary_color = theme?.palette?.primary?.main || defaultColor;
  const secondary_color = theme?.palette?.secondary?.main || defaultColor;

  const location = useLocation();
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const path = location.pathname;

  function isMongoIdInUrl() {
    // Regular expression to match a MongoDB ObjectID
    const objectIdRegex = /\/[a-f\d]{24}$/;

    // Test the URL against the regex
    return objectIdRegex.test(path);
  }

  const breadcrumbs = [
    {
      path: "/late-ship",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Order Exceptions",
        },
      },
    },
    {
      path: "/sales-analysis",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Sales over Time",
        },
      },
    },
    {
      path: "/sales-history",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Sales by Product",
        },
      },
    },
    {
      path: "/lost-sales-analysis",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Lost Sales Analysis",
        },
      },
    },
    {
      path: "/inventory-analysis",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Inventory Analysis",
        },
      },
    },
    {
      path: "/inventory-health",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Inventory Health",
        },
      },
    },
    {
      path: "/inventory-risk",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Inventory Risk by Product",
        },
      },
    },
    {
      path: "/purchase-order-analysis",
      data: {
        title: "Insight",
        link: "/insight",
        subNav: {
          title: "Purchase Order Analysis",
        },
      },
    },
    {
      path: "/supply-flow",
      data: {
        title: "Command Center",
        link: "/",
        subNav: {
          title: "Supply Flow",
        },
      },
    },
    {
      path: "/insight",
      data: {
        title: "Insight",
        link: "/insight",
      },
    },
    {
      path: "/order-flow",
      data: {
        title: "Order",
        link: "/order-management?child=true",
        subNav: {
          title: "Order Work Flow",
          subNav2: { title: "" },
        },
      },
    },
    {
      path: "/account-setting",
      data: {
        title: "Account Setting",
        link: "/account-setting",
        // subNav: {
        //   title: "Account Setting",
        //   subNav2: { title: "" },
        // },
      },
    },
    {
      path: "/manage-product",
      data: {
        title: "Product",
        subNav: {
          title: "Product List",
          link: "/product",
          subNav2: {
            title: `${isMongoIdInUrl() ? "Edit" : "Add"} Product`,
          },
        },
      },
    },
    {
      path: "/manage-catalog",
      data: {
        title: "Product",
        subNav: {
          title: "Catalog",
          link: "/catalog",
          subNav2: {
            title: `${isMongoIdInUrl() ? "Edit" : "Add"} Catalog`,
          },
        },
      },
    },
    {
      path: "/order-tracking-history",
      data: {
        title: "Order",
        link: "/order-management?child=true",
        subNav: {
          title: "Order Tracking History",
        },
      },
    },
    {
      path: "/assign-user",
      data: {
        title: "Account Setting",
        link: "/account-setting",
        subNav: {
          title: "Assign User",
        },
      },
    },
    {
      path: "/client-config",
      data: {
        title: "Account Setting",
        link: "/account-setting",
        subNav: {
          title: "Config",
        },
      },
    },
    {
      path: "/track-order",
      data: {
        title: "Order Tracking",
        subNav: { title: "" },
      },
    },
    {
      path: "/update-asn",
      data: {
        title: "Inventory",
        subNav: {
          title: "Purchase Order",
          link: "/purchase-order?child=true",
          subNav2: {
            title: `Update P.O.`,
          },
        },
      },
    },
    {
      path: "/add-asn",
      data: {
        title: "Inventory",
        subNav: {
          title: "Purchase Order",
          link: "/purchase-order?child=true",
          subNav2: {
            title: `Create P.O.`,
          },
        },
      },
    },
    {
      path: "/planning-forecast",
      data: {
        title: "Planning",
        subNav: {
          title: "Forecast",
        },
      },
    },
    {
      path: "/planning-forecast-new",
      data: {
        title: "Planning",
        subNav: {
          title: "Forecast New",
        },
      },
    },
    {
      path: "/transfer-orders",
      data: {
        title: "Transfer Orders",
      },
    },
    {
      path: "/updated-forecast",
      data: {
        title: "Inventory",
        subNav: {
          title: "Updated Forecast",
        },
      },
    },
    {
      path: "/forecast",
      data: {
        title: "Planning",
        subNav: {
          title: "Forecast",
          link: "/planning-forecast",
          subNav2: {
            title: "Custom Forecast",
          },
        },
      },
    },
    {
      path: "/asn-tracking",
      data: {
        title: "Inventory",
        subNav: {
          title: location.search?.includes("inventory")
            ? "Inventory"
            : "Purchase Order",
          link: location.search?.includes("inventory")
            ? "/inventory?child=true"
            : "/purchase-order?child=true",
          subNav2: {
            title: `Purchase Order Tracking`,
          },
        },
      },
    },
    {
      path: "/order-import",
      data: {
        title: "Order",
        link: "order-management",
        subNav: {
          title: "Import Order",
        },
      },
    },
    {
      path: "/product-import",
      data: {
        title: "Product",
        subNav: {
          title: "Product List",
          link: "product",
          subNav2: {
            title: "Import Product",
          },
        },
      },
    },
    {
      path: "/supplier-config-import",
      data: {
        title: "Product",
        subNav: {
          title: "Product List",
          link: "product",
          subNav2: {
            title: "Import Supplier Configuration",
          },
        },
      },
    },
    {
      path: "/catalog-import",
      data: {
        title: "Product",
        subNav: {
          title: "Catalog",
          link: "catalog",
          subNav2: {
            title: "Import Catalog",
          },
        },
      },
    },
    {
      path: "/historical-data-import",
      data: {
        title: "Historical Data",
        link: "historical-order",
        subNav: {
          title: "Import Historical Data",
        },
      },
    },
    {
      path: "/shipment-import",
      data: {
        title: "Historical Shipment",
        link: "historical-shipments",
        subNav: {
          title: "Import Shipment",
        },
      },
    },
    {
      path: "/historical-inventory",
      data: {
        title: "Historical Data",
        subNav: {
          title: "Historical Inventory",
          link: "historical-inventory",
          subNav2: {
            title: "Import Historical Inventory",
          },
        },
      },
    },
    {
      path: "/historical-inventory-snapshot-health",
      data: {
        title: "Historical Data",
        subNav: {
          title: "Historical Inventory",
          link: "historical-inventory",
          subNav2: {
            title: "Snapshot Health",
          },
        },
      },
    },
    {
      path: "/inventory-config",
      data: {
        title: "Product",
        subNav: {
          title: "Product List",
          link: "product",
          subNav2: {
            title: "Inventory/Supplier Configuration",
          },
        },
      },
    },
    {
      path: "/inventory-import",
      data: {
        title: "Inventory",
        subNav: {
          title: "Inventory List",
          link: "inventory",
          subNav2: {
            title: "Inventory Import",
          },
        },
      },
    },
    {
      path: "/manage-market-data",
      data: {
        title: "DropSkip Tool",
        link: "market-data",
        subNav: {
          title: "Manage Market Data",
        },
      },
    },
    {
      path: "/asn-tracking",
      data: {
        title: "Inventory",
        link: "purchase-order",
        subNav: {
          title: "Purchase Order Tracking",
        },
      },
    },
    {
      path: "/m2o-order/create",
      data: {
        title: "Order",
        link: "/order-management",
        subNav: {
          title: "Create M2O Order",
        },
      },
    },
    {
      path: "/create-order",
      data: {
        title: "Order",
        link: "/order-management",
        subNav: {
          title: "Create Order",
        },
      },
    },
    {
      path: "/network-design",
      data: {
        title: "Network Design",
        link: "/network-design",
      },
    },
    {
      path: "/view-network-design",
      data: {
        title: "Network Design",
        link: "/view-network-design",
        subNav: {
          title: "View",
        },
      },
    },
    {
      path: "/parameter-value-import",
      data: {
        title: "Historical Data",
        link: "historical-order",
        subNav: {
          title: "Import Data",
        },
      },
    },
    {
      path: "/admin-config",
      data: {
        title: "Account Setting",
        link: "/account-setting",
        subNav: {
          title: "Admin Config",
        },
      },
    },
    {
      path: "/sales-by-category-import",
      data: {
        title: "Sales By Category",
        link: "sales-by-category",
        subNav: {
          title: "Import Sales By Category",
        },
      },
    },
    {
      path: "/catalog-planner",
      data: {
        title: "Planning",
        subNav: {
          title: "Demand",
          link: "/catalog-plans",
          subNav2: {
            title: "Demand Planner",
          },
        },
      },
    },
    {
      path: "/supplier-import",
      data: {
        title: "Product",
        subNav: {
          title: "Supplier",
          link: "/supplier",
          subNav2: {
            title: "Import Supplier",
          },
        },
      },
    },
    {
      path: "/purchase-order-import",
      data: {
        title: "Inventory",
        subNav: {
          title: "Purchase Order",
          link: "/purchase-order",
          subNav2: {
            title: "Import Purchase Order",
          },
        },
      },
    },
    {
      path: "/master-purchase-order-import",
      data: {
        title: "Inventory",
        subNav: {
          title: "Master Purchase Order",
          link: "/master-purchase-order",
          subNav2: {
            title: "Import Master Purchase Order",
          },
        },
      },
    },
  ];
  // Demand plan forecast view: Planning › Demand › Demand Planner (back to the
  // plan) › Forecasted · <category>. The category name comes with the
  // navigation (route state); the page fills it in when opened by URL.
  const planForecast = path.match(/^\/catalog-planner\/([a-f\d]{24})\/forecast\//);
  const breadcrumbData = planForecast
    ? {
        title: "Planning",
        subNav: {
          title: "Demand",
          link: "/catalog-plans",
          subNav2: {
            title: "Demand Planner",
            link: `/catalog-planner/${planForecast[1]}`,
            subNav3: {
              title: location.state?.categoryName
                ? `Forecasted · ${location.state.categoryName}`
                : "Forecasted",
            },
          },
        },
      }
    : breadcrumbs.find((x) => path.includes(x.path))?.data ||
      getObjectByPath(path, user?.role);

  return (
    <MUIBreadcrumbs
      aria-label="breadcrumb"
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={{ color: colors.textSecondary }}
        />
      }
    >
      <Link component={RouterLink} color={primary_color || "#DC585C"} to="/">
        <HomeIcon fill={primary_color || "#DC585C"} />
      </Link>
      {breadcrumbData?.title &&
        (breadcrumbData?.link ? (
          <Link
            component={RouterLink}
            to={breadcrumbData.link}
            style={{ textDecoration: "none", color: primary_color }}
          >
            <CustomTypography
              fontSize={isMobile() ? 12 : "14px"}
              fontWeight={600}
              color={primary_color}
            >
              {breadcrumbData.title}
            </CustomTypography>
          </Link>
        ) : (
          <CustomTypography
            color={primary_color}
            fontSize={isMobile() ? 12 : "14px"}
            fontWeight={600}
          >
            {breadcrumbData.title}
          </CustomTypography>
        ))}
      {breadcrumbData?.subNav?.title &&
        (breadcrumbData.subNav?.link ? (
          <Link
            component={RouterLink}
            to={breadcrumbData.subNav.link}
            style={{ textDecoration: "none", color: secondary_color }}
          >
            <CustomTypography
              color={
                breadcrumbData?.subNav?.subNav2?.title
                  ? primary_color
                  : secondary_color
              }
              fontSize={isMobile() ? 12 : "14px"}
              fontWeight={600}
            >
              {breadcrumbData.subNav.title}
            </CustomTypography>
          </Link>
        ) : (
          <CustomTypography
            color={secondary_color}
            fontSize={isMobile() ? 12 : "14px"}
            fontWeight={600}
          >
            {breadcrumbData.subNav.title}
          </CustomTypography>
        ))}
      {breadcrumbData &&
        breadcrumbData?.subNav?.subNav2 &&
        (breadcrumbData.subNav.subNav2.link ? (
          <Link
            component={RouterLink}
            to={breadcrumbData.subNav.subNav2.link}
            style={{ textDecoration: "none" }}
          >
            <CustomTypography
              color={
                breadcrumbData.subNav.subNav2.subNav3
                  ? primary_color
                  : secondary_color || "#757575"
              }
              fontSize={isMobile() ? 12 : "14px"}
              fontWeight={600}
            >
              {breadcrumbData.subNav.subNav2.title}
            </CustomTypography>
          </Link>
        ) : (
          <CustomTypography
            color={secondary_color || "#757575"}
            fontSize={isMobile() ? 12 : "14px"}
            fontWeight={600}
          >
            {breadcrumbData.subNav?.subNav2?.title}
          </CustomTypography>
        ))}
      {breadcrumbData?.subNav?.subNav2?.subNav3 && (
        <CustomTypography
          color={secondary_color || "#757575"}
          fontSize={isMobile() ? 12 : "14px"}
          fontWeight={600}
        >
          {breadcrumbData.subNav.subNav2.subNav3.title}
        </CustomTypography>
      )}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
